import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { Modal, ModalActions } from "../../../../../Components/Modal";
import ModalTitle from "../../../../../Components/Modal/ModalTitle";
import ModalBody from "../../../../../Components/Modal/ModalBody";
import { useTranslation } from "../../../../../context/Internationalization";

const DeleteConfirmationModal = ({ open, onClose, onDelete }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle title={t("delete_field")} />
      <ModalBody>
        <span>
          {t("delete_field_warning_msg")}
          <br /> {t("delete_activity_confirmation_subtitle")}
        </span>
      </ModalBody>
      <ModalActions>
        <Button
          variant={"outlined"}
          color={"secondary"}
          fullWidth
          onClick={onClose}
        >
          {t("close")}
        </Button>
        <Button
          variant={"contained"}
          color={"error"}
          fullWidth
          onClick={onDelete}
        >
          {t("delete")}
        </Button>
      </ModalActions>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {};

export default DeleteConfirmationModal;
